import { LOGIN_SUCCESS } from "../../../constants/actionTypes"

export default (payload) => (dispatch) => {
    dispatch({
        type: LOGIN_SUCCESS,
        payload: payload
    })
}